import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={32}
    height={32}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:none;stroke:#060b0c;stroke-miterlimit:10}"}</style>
    </defs>
    <g id="Palette">
      <path
        d="m26.34 2.83 2.83 2.83L6.69 28.14l-3.86 1.04 1.04-3.86L26.34 2.83m0-2.83L2.07 24.27 0 32l7.73-2.07L32 5.66 26.34 0Z"
        style={{
          fill: "#060b0c",
          strokeWidth: 0,
        }}
      />
      <path d="m23.26 4.49 4.25 4.25M2.78 24.98l4.24 4.24" className="cls-1" />
    </g>
  </svg>
)
export default SvgComponent
